import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Loader2, UserPlus } from "lucide-react";

export default function Register() {
    const { register } = useAuth();
    const nav = useNavigate();
    const [form, setForm] = useState({ name: "", email: "", password: "" });
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await register(form.email, form.password, form.name);
            toast.success("¡Cuenta creada! Vamos a tu panel.");
            nav("/dashboard");
        } catch (err) {
            toast.error(formatApiError(err));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="max-w-md mx-auto px-4 py-16" data-testid="register-page">
            <div className="brut-card p-8 grain">
                <div className="text-xs uppercase tracking-[0.3em] font-bold opacity-60 mb-1">Empieza gratis</div>
                <h1 className="font-display font-black text-4xl uppercase mb-6">Crea tu cuenta</h1>
                <form onSubmit={submit} className="space-y-4">
                    <div>
                        <label htmlFor="name" className="brut-label">Nombre</label>
                        <input
                            id="name"
                            required
                            value={form.name}
                            onChange={(e) => setForm({ ...form, name: e.target.value })}
                            className="brut-input"
                            placeholder="Juan Pérez"
                            data-testid="register-name"
                        />
                    </div>
                    <div>
                        <label htmlFor="email" className="brut-label">Email</label>
                        <input
                            id="email"
                            type="email"
                            required
                            value={form.email}
                            onChange={(e) => setForm({ ...form, email: e.target.value })}
                            className="brut-input"
                            placeholder="tu@email.com"
                            data-testid="register-email"
                        />
                    </div>
                    <div>
                        <label htmlFor="password" className="brut-label">Contraseña</label>
                        <input
                            id="password"
                            type="password"
                            required
                            minLength={6}
                            value={form.password}
                            onChange={(e) => setForm({ ...form, password: e.target.value })}
                            className="brut-input"
                            placeholder="Mínimo 6 caracteres"
                            data-testid="register-password"
                        />
                    </div>
                    <button type="submit" disabled={loading} className="brut-btn brut-btn-primary w-full" data-testid="register-submit">
                        {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <UserPlus className="w-4 h-4" strokeWidth={3} />}
                        Crear cuenta
                    </button>
                </form>
                <p className="text-center text-sm mt-6">
                    ¿Ya tienes cuenta? <Link to="/login" className="underline text-coral font-bold">Ingresa</Link>
                </p>
            </div>
        </div>
    );
}
